export const environment = {
  ENV: 'dit',
  APP: 'asm-platform',
  ASM_LICENSING_URL: 'https://asm-licensing.ditext.outpost24.com',
  THEME: 'asm-light',
  KEYCLOAK_REALM: 'asm',
  KEYCLOAK_URL: 'https://asm-auth.ditext.outpost24.com/auth',
  KEYCLOAK_CLIENT_ID: 'asm-platform',
  ASM_API_URL: 'https://asm-backend.ditext.outpost24.com',
  // ASM_API_URL: 'http://localhost:5000',
  LEGACY_ASM_PLATFORM_URL: 'https://asm-platform.ditext.outpost24.com',
  LEGACY_ASM_ADMIN_URL: 'https://asm-admin.ditext.outpost24.com',
  OUTSCAN_URL: 'https://outscan.uat.outpost24.com',
  LICENSE_SERVICE_QUERY_URL: 'https://license.ditext.outpost24.com/api',
  LICENSE_SERVICE_COMMAND_URL: 'https://license-cmd.ditext.outpost24.com/api',
  // LICENSE_SERVICE_QUERY_URL: 'http://localhost:8080/api',
  // LICENSE_SERVICE_COMMAND_URL: 'http://localhost:8081/api',
  SOL_CATALOG_URL: 'https://sol-catalog.ditext.outpost24.com',
  ASM_PROTOTYPE_URL: 'https://asm-prototype.ditext.outpost24.com',
  CUSTOMER_API_URL: 'https://asm-backend.ditext.outpost24.com',
  HTTP_MOCKS: [],
  SMOKE_TEST_API_URL: 'http://localhost:8000',
  PENDO_API_KEY: '0ec4ba27-7e87-4c57-9dc3-2f8aecd96c0b',
};
